import { AutogenLayoutTariffRegionAdvanceSearch } from "./autogen/AutogenLayoutTariffRegionAdvanceSearch";

export class TariffRegionAdvanceSearch extends AutogenLayoutTariffRegionAdvanceSearch {

}
